import { connectNotificacoesStream } from "@spark/services/notificacoes/stream";
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import NotificationsIcon from 'mdi-react/NotificationsIcon';
import { TopbarBack, TopbarButton } from './BasicTopbarComponents';
import { TopbarCollapse, TopbarCollapseButton, TopbarCollapseContent, TopbarCollapseDate, TopbarCollapseImageWrap, TopbarCollapseItem, TopbarCollapseLink, TopbarCollapseMessage, TopbarCollapseName, TopbarCollapseTitle, TopbarCollapseTitleWrap } from './CollapseTopbarComponents';
import styled from 'styled-components';
import { notification } from '@spark/ui-components/utils/notification';

const TopbarNotification = () => {
  const history = useHistory();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [notificacoes, setNotificacoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalNaoLidas, setTotalNaoLidas] = useState(0);
  useEffect(() => {
    if (isCollapsed) {
      loadNotificacoes();
    }
  }, [isCollapsed]); // Buscar notificações ao montar (para popular badge)

  useEffect(() => {
    loadNotificacoes();
  }, []); // Conecta ao stream SSE e atualiza quando chegar evento

  useEffect(() => {
    
  }, []);

  const loadNotificacoes = async () => {
    try {
      setLoading(true);
      const lista = Array.isArray(response?.registros) ? response.registros : Array.isArray(response) ? response : [];
      setNotificacoes(lista);

      if (typeof response?.totalNaoLidas === 'number') {
        setTotalNaoLidas(response.totalNaoLidas);
      } else {
        const calc = lista.filter(n => !n.Lida).length;
        setTotalNaoLidas(calc);
      }
    } catch (error) {
      setNotificacoes([]);
      setTotalNaoLidas(0);
    } finally {
      setLoading(false);
    }
  };

  const handleMarcarLida = async notificacao => {
    try {
      setNotificacoes(prev => prev.map(n => n.Id === notificacao.Id ? { ...n,
        Lida: true
      } : n));
    } catch {}
  };

  const handleMarcarTodasLidas = async () => {
    try {
      await marcarComoLida('todas');
      setNotificacoes(prev => prev.map(n => ({ ...n,
        Lida: true
      })));
    } catch {}
  };

  const handleVisualizar = notificacao => {
    if (!notificacao.Lida) {
      handleMarcarLida(notificacao);
    }

    if (notificacao.AcompanhamentoId) {
      history.push(`/pages/acompanhamentos/detalhes/${notificacao.AcompanhamentoId}`);
    }

    setIsCollapsed(false);
  };

  const notificacoesNaoLidas = totalNaoLidas;

  const formatDate = dateString => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));

    if (diffInHours < 1) {
      return 'Agora mesmo';
    } else if (diffInHours < 24) {
      return `${diffInHours}h atrás`;
    } else {
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  };

  const collapseNotification = () => {
    setIsCollapsed(!isCollapsed);
  };

  return <TopbarCollapse>
      <TopbarButton type="button" onClick={collapseNotification}>
        <NotificationsIcon />
        {notificacoesNaoLidas > 0 && <NotificationCount>
            {notificacoesNaoLidas > 99 ? '99+' : notificacoesNaoLidas}
          </NotificationCount>}
        
      </TopbarButton>
      {isCollapsed && <TopbarBack aria-label="topbar__back" type="button" onClick={collapseNotification} />}

      
      <Collapse in={isCollapsed}>
        <TopbarCollapseContent>
          <TopbarCollapseTitleWrap>
            <TopbarCollapseTitle>Notificações</TopbarCollapseTitle>
            {notificacoesNaoLidas > 0 && <TopbarCollapseButton type="button" onClick={handleMarcarTodasLidas}>
                Marcar todas como lidas
              </TopbarCollapseButton>}
            
          </TopbarCollapseTitleWrap>
          {loading ? <TopbarCollapseItem>
              <TopbarCollapseMessage>
                <TopbarCollapseName>Carregando...</TopbarCollapseName>
              </TopbarCollapseMessage>
            </TopbarCollapseItem> : notificacoes.length === 0 ? <TopbarCollapseItem>
              <TopbarCollapseMessage>
                <TopbarCollapseName>Nenhuma notificação</TopbarCollapseName>
              </TopbarCollapseMessage>
            </TopbarCollapseItem> : <>
              {notificacoes.map(notificacao => <TopbarCollapseItem key={notificacao.Id} onClick={() => handleVisualizar(notificacao)} style={{
            cursor: 'pointer',
            background: !notificacao.Lida ? 'rgba(112,187,253,0.08)' : 'transparent'
          }}>
              
                  <TopbarCollapseMessage style={{
              maxWidth: 'calc(100% - 80px)'
            }}>
                    <TopbarCollapseName style={{
                fontWeight: !notificacao.Lida ? '600' : '400',
                color: !notificacao.Lida ? '#70bbfd' : undefined
              }}>
                      <TitleText title={notificacao.Titulo}>{notificacao.Titulo}</TitleText>
                    </TopbarCollapseName>
                    <MessageText title={notificacao.Mensagem}>
                      {notificacao.Mensagem || ''}
                    </MessageText>
                  </TopbarCollapseMessage>
                  <TopbarCollapseDate>
                    {formatDate(notificacao.DataCriacao)}
                  </TopbarCollapseDate>
                </TopbarCollapseItem>)}
            
            </>}
          
          <TopbarCollapseLink to="/pages/notificacoes" onClick={collapseNotification}>
            Ver todas as notificações
          </TopbarCollapseLink>
        </TopbarCollapseContent>
      </Collapse>
    </TopbarCollapse>;
};

export default TopbarNotification;
const NotificationCount = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background-color: #e0536f;
  color: white;
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 10px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`; // Texto com elipse para não quebrar layout

const TitleText = styled.span`
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const MessageText = styled.span`
  display: block;
  max-width: 100%;
  color: #6b6b6b;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
